<template>
  <div id="app" class="min-h-screen w-screen">
    <router-view />
  </div>
  <!-- <img class="h-auto w-full fixed bottom-0 left-0 contain object-contain select-auto" src="./assets/grass.svg"> -->
  
</template>
<script>
  export default {
    watch: {
      // Set meta tags
      $route(to) {
        this.setMeta(to.meta);
      },
    },
    methods: {
      setMeta(meta) {
        document.title = meta.title;
        if(meta.title === undefined)
        {
          document.title = 'Przedszkole';
        }
      }
    }
  }
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

html, body {
  font-family: 'Poppins', sans-serif;
  overflow-x: hidden;
  background-color:#FFECC1;

}

#app {
  font-family: 'Poppins', sans-serif;
}

</style>